import { PageInfo } from "@/components/Pagination";
import { TypedDocumentNode, gql } from "@apollo/client";
import type { BankConnectionProvider } from "@/pages/people/[pgaId]/billing/payout-profiles/bankConnectionProvider";

export interface PayoutProfileNode {
  id: string;
  name: string;
  address: string;
  address2?: string | null;
  city: string;
  stateDisplay: string;
  postalCode: string;
  taxClassification?: string | null;
  taxFormType?: string | null;
  status: string;
  defaultPayoutProfile: boolean;
  businessName?: string | null;
  createdAt: string;
  updatedAt: string;
  bankName?: string | null;
  bankAccountMaskedNumber?: string | null;
  bankConnectionProvider?: BankConnectionProvider | null;
  bankReauthorizationRequired?: boolean;
  stripeFcExpectedExpiryDate?: string | null;
  stripeFcAccountNumberStatus?: string | null;
  stripeFcAccountNumberIdentifierType?: string | null;
  workdayUserError?: string | null;
  workdayServerException?: string | null;
  person?: {
    pgaId: string | null;
    email?: string;
    firstName?: string;
    lastName?: string;
    profilePhoto?: string | null;
    mainProgramType?: { name: string } | null;
  } | null;
}

type Query = {
  payoutProfiles: {
    totalCount: number;
    nodes: PayoutProfileNode[];
    pageInfo: PageInfo;
  };
};

export const ALL_PAYOUT_PROFILES_QUERY: TypedDocumentNode<Query> = gql`
  query GetAllPayoutProfiles(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $query: String
    $statuses: [String!]
  ) {
    payoutProfiles(
      first: $first
      last: $last
      after: $after
      before: $before
      filters: { search: $query, statuses: $statuses }
    ) {
      nodes {
        id
        name
        address
        city
        stateDisplay
        postalCode
        taxClassification
        taxFormType
        status
        defaultPayoutProfile
        businessName
        createdAt
        updatedAt
        bankName
        bankAccountMaskedNumber
        bankConnectionProvider
        bankReauthorizationRequired
        stripeFcExpectedExpiryDate
        stripeFcAccountNumberStatus
        stripeFcAccountNumberIdentifierType
        workdayUserError
        workdayServerException
        person {
          pgaId
          firstName
          lastName
          email
          profilePhoto
          mainProgramType {
            name
          }
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const SYNC_WORKDAY_SUPPLIER_MUTATION = gql`
  mutation SyncWorkdaySupplier($payoutProfileId: ID!) {
    syncWorkdaySupplier(payoutProfileId: $payoutProfileId) {
      success
      message
    }
  }
`;
